import React from "react";
import styles from "../../styles/Videos/video.module.css";

const IndividualCategory = ({ title, description, thumbnail, click }) => {
  return (
    <div className={styles.singleCategoryContainer} onClick={click} style={{ cursor: "pointer" }}>
      <div className={styles.categoryImageContainer}>
        <img src={thumbnail} alt="thumbnail" />
      </div>
      <div className={styles.categoryDescContainer}>
        <div className={styles.categoryTitle}>{title}</div>
        <div className={styles.categoryDesc}>{description}</div>
      </div>
    </div>
  );
};

export default IndividualCategory;
